import React, { useEffect, useState } from "react";
import {
  CircularProgress,
  Divider
} from "@material-ui/core";

import Widget from "../Widget";
import { Typography } from "../Wrappers";
import config from "../../config";
import useStyles from "./styles";

export default function ApprovedLimitReminder() {
  const classes = useStyles();

  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    async function fetchData() {
      try {
        const response = await fetch(
          `${config.clientApi}/dashboard/approved-limit-reminders`,
          {
            credentials: "include"
          }
        );

        const json = await response.json();

        if (mounted) {
          setJobs(Array.isArray(json) ? json : []);
          setLoading(false);
        }
      } catch (e) {
        console.error(e);

        if (mounted) {
          setJobs([]);
          setLoading(false);
        }
      }
    }

    fetchData();

    return () => mounted = false;
  }, []);

  function openJob(jobId) {
    window.open(
          `${config.adminApi}/#/app/job/edit/${jobId}`,
          '_blank'
        );
  }

  function limitLabel(type) {
    return type === "TAGS" ? "tag limit" : "hour limit";
  }

  if (loading) {
    return (
      <Widget title="Jobs Missing Approved Limits" disableWidgetMenu>
        <CircularProgress size={24} />
      </Widget>
    );
  }

  // Nothing needs attention, don't take up dashboard space.
  if (jobs.length === 0) {
    return null;
  }

  return (
    <Widget
      title="Jobs Missing Approved Limits"
      disableWidgetMenu
      showOverflow
    >
      <Typography
        size="sm"
        color="text"
        colorBrightness="secondary"
        className={classes.helperText}
      >
        Upcoming jobs that require an approved limit before testing begins.
      </Typography>

      {jobs.map((job, index) => (
        <React.Fragment key={job.id}>
          {index > 0 && <Divider />}

          <div
            className={classes.jobRow}
            onClick={() => openJob(job.id)}
          >
            <div>
              <Typography weight="medium">
                Job #{job.id} · {job.customer}
              </Typography>

              <Typography
                size="sm"
                color="text"
                colorBrightness="secondary"
              >
                {job.site} · {job.start_date}
              </Typography>
            </div>

            <Typography
              size="sm"
              className={classes.warningText}
            >
              Missing approved {limitLabel(job.approved_limit_type)}
            </Typography>
          </div>
        </React.Fragment>
      ))}
    </Widget>
  );
}
